import {Injectable} from '@angular/core';
import {environment} from "../../../environments/environment";

@Injectable()
export class CdnService {

  private cdnUrl: string;

  constructor() {
    this.cdnUrl = environment.cdnUrl;
  }

  getImageUrl(fileId, filename, size = 'small') {
    if (filename.indexOf('http') > -1) {
      return filename;
    }

    return this.cdnUrl + 'public/'+ fileId + '/' + filename;
  }

  getFileUrl(fileId, filename) {
    if (filename.indexOf('http') > -1) {
      return filename;
    }

    return this.cdnUrl + 'public/'+ fileId + '/' + filename;
  }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/shared/services/cdn.service.ts